import { EMPTY_LIST } from '../../../constants/common'
import { FORMIK_EMPTY_VALUE } from '../../../constants/validation'
import { TASK_FORM_YES_NO_OPTION_VALUE } from '../TaskFormYesNoConfirmationModal'

// FIELD NAMES
export const TASK_FORM_CONFIGURATION_FIELD_NAME = 'commit_type'

export const TASK_FORM_DEADLINE_FIELD_NAME = 'deadline'

export const TASK_FORM_DESCRIPTION_FIELD_NAME = 'notes'

export const TASK_FORM_FILES_FIELD_NAME = 'files'

export const TASK_FORM_ID_FIELD_NAME = 'id' // ID can be only in editing form

export const TASK_FORM_MANAGER_FIELD_NAME = 'manager'

export const TASK_FORM_MARK_AS_DONE_FIELD_NAME = 'done'

export const TASK_FORM_PHASE_FIELD_NAME = 'phase'

export const TASK_FORM_PRIORITY_FIELD_NAME = 'priority'

export const TASK_FORM_SERVICE_REQUEST_FIELD_NAME = 'service_request'

export const TASK_FORM_TITLE_FIELD_NAME = 'title'

export const TASK_FORM_TYPE_FIELD_NAME = 'type'

export const TASK_FORM_VISIBILITY_FIELD_NAME = 'visible_to_tenant'

export const TASK_FORM_YES_NO_FIELD_NAME = 'yesno'

export const TASK_FORM_EMAILS_THREADS_FIELD_NAME = 'request_threads'

// READONLY FIELDS
export const TASK_FORM_CREATED_FIELD_NAME = 'created'

export const TASK_FORM_FINISHED_FIELD_NAME = 'finished'

export const TASK_FORM_UPDATED_FIELD_NAME = 'updated'
// END READONLY FIELDS

// END FIELDS NAMES

export const TASK_FORM_DESCRIPTION_FIELD_MAX_LENGTH = 2000

export const TASK_FORM_TITLE_FIELD_MAX_LENGTH = 256

export const TASK_FORM_CONFIGURATION_FIELD_OPTION_VALUE = {
  checklist: 'done',
  yesNo: 'yesno',
}

export const TASK_FORM_INITIAL_VALUES = {
  [TASK_FORM_CONFIGURATION_FIELD_NAME]:
    TASK_FORM_CONFIGURATION_FIELD_OPTION_VALUE.checklist,
  [TASK_FORM_DEADLINE_FIELD_NAME]: null,
  [TASK_FORM_DESCRIPTION_FIELD_NAME]: FORMIK_EMPTY_VALUE,
  [TASK_FORM_EMAILS_THREADS_FIELD_NAME]: EMPTY_LIST,
  [TASK_FORM_FILES_FIELD_NAME]: EMPTY_LIST,
  [TASK_FORM_MANAGER_FIELD_NAME]: null,
  [TASK_FORM_MARK_AS_DONE_FIELD_NAME]: false,
  [TASK_FORM_PHASE_FIELD_NAME]: null,
  [TASK_FORM_PRIORITY_FIELD_NAME]: null,
  [TASK_FORM_SERVICE_REQUEST_FIELD_NAME]: null,
  [TASK_FORM_TITLE_FIELD_NAME]: FORMIK_EMPTY_VALUE,
  [TASK_FORM_TYPE_FIELD_NAME]: null,
  [TASK_FORM_VISIBILITY_FIELD_NAME]: false,
  [TASK_FORM_YES_NO_FIELD_NAME]: null,
}

export const TASK_FORM_YES_NO_CONFIRMATION_MODAL_INITIAL_VALUES = {
  [TASK_FORM_YES_NO_FIELD_NAME]: TASK_FORM_YES_NO_OPTION_VALUE.Yes,
}

export const TASK_FORM_MOBILE_ACTIONS_MAX_WIDTH = 600 // px
